import React from "react";
import AboutSection from "../components/AboutSection";
import BannerHome from "../components/BannerHome";
import FooterOne from "../components/Footer/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceArea from "../components/ServiceArea";
import ExecutiveDirector from "../components/ExecutiveDirector";
import Partners from "../components/Partners";
import RecentNewsHome from "../components/RecentNewsHome";

const HomeOne = () => {
  return (
    <>
      <NavBar />
      <BannerHome />
      <AboutSection />
      <ExecutiveDirector />
      <ServiceArea />
      <Partners />
      <RecentNewsHome />
      <FooterOne />
    </>
  );
};

export default HomeOne;
